import {useDebugValue} from 'react';

import {
    useDestinationSummaryEvents
} from './';

function useDestinationSummary(props) {
    const {
        events
    } = useDestinationSummaryEvents(props);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useDestinationSummary};
